import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material"
import { useAppSelector } from "../../../../../../../hooks/store-hooks"
import { useListaDeduplicacaoService } from "../../../../../../../../use-cases/geo-veles"
import { useState } from "react"
import { formatCep, formatCPF } from "../../../../../../../../utils"

export const EditCPF = (props: {
    openEditCPF: boolean
    oldCPF: string
}) => {
    // State
    const { listaDeduplicacao } = useAppSelector((state) => state)
    // Use State
    const [newCep, setNewCep] = useState<string>(props.oldCPF)
    // Hook
    const { openEditCPF, listaDeduplicacaoEditCPF } = useListaDeduplicacaoService()

    const handleClose = () => {
        openEditCPF(false);
        setNewCep('')
    };

    return (
        <>
            {
                props.openEditCPF === true &&
                <Dialog
                    open={listaDeduplicacao.openEditCPF}
                    onClose={handleClose}
                    hideBackdrop
                >
                    <DialogTitle>Editar CPF</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Digite abaixo o novo CPF atualizado.
                        </DialogContentText>
                        <Box mt={3}>
                            <TextField
                                InputLabelProps={{
                                    shrink: true
                                }}
                                autoFocus
                                value={newCep.length >= 11 ? formatCPF(newCep) : newCep}
                                margin="dense"
                                label="Digite o novo CPF"
                                type="text"
                                fullWidth
                                variant="standard"
                                onChange={(e) => {
                                    setNewCep(e.target.value.replace(/\D/g, ""))
                                }}
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleClose}
                        >
                            Cancelar
                        </Button>
                        <Button
                            autoFocus
                            onClick={() => {
                                handleClose()
                                listaDeduplicacaoEditCPF({
                                    CPF: props.oldCPF,
                                    newCPF: formatCep(newCep)
                                })
                            }}
                        >
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
}